// Add your custom JS here.

jQuery(function ($) {
    /* add background color to navbar in scroll */
    $(document).scroll(function () {
        console.log('scrolled');
        var $nav = $(".fixed-top");
        $nav.toggleClass('bg-primary', $(this).scrollTop() > $nav.height()-100);
		$nav.toggleClass('mt-0', $(this).scrollTop() > $nav.height()-100);
			
      });

      /* Search Menu */
	
	$(".search-icon").click(function() {
		$(".tdmsearchform").slideToggle();
	});

	$(document).keyup(function(e) {
		// Ref https://stackoverflow.com/questions/3369593/how-to-detect-escape-key-press-with-pure-js-or-jquery
		// Close search if esc key pressed
		if (e.key == "Escape") {
		  $(".tdmsearchform").hide();
		}
	});

	var scrollCount = null;
	var scroll= null;
	/* Feautured carosule */
	jQuery('.feautured-carousel').slick({
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        variableWidth: true,
		prevArrow: $('.arrow-left'),
        nextArrow: $('.arrow-right'),
        responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
				dots: false,
                arrows: false,
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
                infinite: true,
                dots: false,
                arrows: false,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
                infinite: true,
				dots: false,
                arrows: false,
			  }
			}
		]
    });
	/*jQuery('.feautured-carousel').on('wheel', (function(e) {
		e.preventDefault();

		clearTimeout(scroll);
		scroll = setTimeout(function(){scrollCount=0;}, 200);
		if(scrollCount) return 0;
		scrollCount=1;

		if (e.originalEvent.deltaY < 0) {
			$(this).slick('slickNext');
		} else {
			$(this).slick('slickPrev');
		}
	  }));*/
/* Laboratori carosule */

jQuery('.laboratori-carousel').slick({
	arrows: true,
	dots: false,
	slidesToShow: 4,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	infinite: true,
	variableWidth: true,
	prevArrow: $('.wrapper-laboratori .arrow-left'),
	nextArrow: $('.wrapper-laboratori .arrow-right'),
	responsive: [
		{
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		}
	]
});
/*jQuery('.laboratori-carousel').on('wheel', (function(e) {
	e.preventDefault();

		clearTimeout(scroll);
		scroll = setTimeout(function(){scrollCount=0;}, 200);
		if(scrollCount) return 0;
		scrollCount=1;

		if (e.originalEvent.deltaY < 0) {
			$(this).slick('slickNext');
		} else {
			$(this).slick('slickPrev');
		}
  }));*/
/* conferenze-carousel */
jQuery('.conferenze-carousel').slick({
	arrows: true,
	dots: false,
	slidesToShow: 4,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	infinite: true,
	variableWidth: true,
	prevArrow: $('.wrapper-conferenze .arrow-left'),
	nextArrow: $('.wrapper-conferenze .arrow-right'),
	responsive: [
		{
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		}
	]
});
/*jQuery('.conferenze-carousel').on('wheel', (function(e) {
	e.preventDefault();

		clearTimeout(scroll);
		scroll = setTimeout(function(){scrollCount=0;}, 200);
		if(scrollCount) return 0;
		scrollCount=1;

		if (e.originalEvent.deltaY < 0) {
			$(this).slick('slickNext');
		} else {
			$(this).slick('slickPrev');
		}
  }));*/
/* Eventi carosule */
jQuery('.eventi-carousel').slick({
	arrows: true,
	dots: false,
	slidesToShow: 4,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	infinite: true,
	variableWidth: true,
	prevArrow: $('.wrapper-eventi .arrow-left'),
	nextArrow: $('.wrapper-eventi .arrow-right'),
	responsive: [
		{
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		}
	]
});
/*jQuery('.eventi-carousel').on('wheel', (function(e) {
	e.preventDefault();

		clearTimeout(scroll);
		scroll = setTimeout(function(){scrollCount=0;}, 200);
		if(scrollCount) return 0;
		scrollCount=1;

		if (e.originalEvent.deltaY < 0) {
			$(this).slick('slickNext');
		} else {
			$(this).slick('slickPrev');
		}
  }));*/
/* Percorsi carosule */
jQuery('.percorsi-carousel').slick({
    arrows:true,
	dots: false,
	slidesToShow: 3,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	infinite: true,
	variableWidth: true,
	prevArrow: $('.wrapper-percorsi .arrow-left'),
	nextArrow: $('.wrapper-percorsi .arrow-right'),
	responsive: [
		{
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		}
	]
});
/*jQuery('.percorsi-carousel').on('wheel', (function(e) {
	e.preventDefault();

		clearTimeout(scroll);
		scroll = setTimeout(function(){scrollCount=0;}, 200);
		if(scrollCount) return 0;
		scrollCount=1;

		if (e.originalEvent.deltaY < 0) {
			$(this).slick('slickNext');
		} else {
			$(this).slick('slickPrev');
		}
  }));*/
/* correlati carosule */
jQuery('.correlati-carousel').slick({
	arrows: false,
	dots: false,
	slidesToShow: 2,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	infinite: true,
	variableWidth: true,
	responsive: [
		{
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: false,
		  }
		}
	]
});
/*jQuery('.correlati-carousel').on('wheel', (function(e) {
	e.preventDefault();

		clearTimeout(scroll);
		scroll = setTimeout(function(){scrollCount=0;}, 200);
		if(scrollCount) return 0;
		scrollCount=1;

		if (e.originalEvent.deltaY < 0) {
			$(this).slick('slickNext');
		} else {
			$(this).slick('slickPrev');
		}
  }));*/
/* lightbox */
var lightbox = GLightbox({
	selector: '.wp-block-gallery a'
  });

  });